export const CREATE_GROUP = 'CREATE_GROUP';
export const UPDATE_GROUP = 'UPDATE_GROUP';
export const SET_GROUPS = 'SET_GROUPS';
export const REMOVE_GROUP = 'REMOVE_GROUP';
export const UPDATE_GROUP_ADMIN_ACCESS = 'UPDATE_GROUP_ADMIN_ACCESS';
